export enum SharingObjectType {
  resource = 'resource',
  mailTemplate = 'email-template',
  recruitment = 'recruitment',
  form = 'form',
}
